import { createSlice } from '@reduxjs/toolkit';
import { PAYROLL_CATEGORY } from '../../utils/constant/global';

const initialState = {
  currentYear: new Date().getFullYear(),
  selectedPayrun: null,
  selectedPayrunTab: PAYROLL_CATEGORY.LOP,
  selectedLopOrOvertime: null
};

// Config slice
export const payrunSlice = createSlice({
  name: 'payrunSlice',
  initialState,
  reducers: {
    handleYearChange: (state, action) => {
      state.currentYear = action?.payload;
    },
    setSelectedPayrun: (state, action) => {
      state.selectedPayrun = action?.payload;
    },
    setSelectedPayrunTab: (state, action) => {
      state.selectedPayrunTab = action?.payload;
    },
    setSelectedLopOrOvertime: (state, action) => {
      state.selectedLopOrOvertime = action?.payload;
    }
  }
});

// Export actions
export const {
  handleYearChange,
  setSelectedPayrun,
  setSelectedPayrunTab,
  setSelectedLopOrOvertime
} = payrunSlice.actions;
// Export reducer
export const { reducer: payrunReducer } = payrunSlice;
